// Navigation des Moduls `befoerderung` (eager geladen; Quelle UX §2.2–§2.10). Besitzer: Modul befoerderung.
import { ArrowFatLinesUp } from '@phosphor-icons/react';
import { defineMeta } from '@web/registry/define';

export default defineMeta({
  key: 'befoerderung',
  title: 'Promotions',
  nav: {
    people: [
      {
        key: 'befoerderung.tab',
        label: 'Promotions',
        icon: ArrowFatLinesUp,
        path: '/promotions',
        roles: ['ALL'],
        order: 30,
        area: 'tabs:performance',
      },
    ],
    admin: [
      {
        key: 'befoerderung.admin',
        label: 'Promotions',
        icon: ArrowFatLinesUp,
        path: '/performance/promotions',
        // SPEC §1.5/D9: PERF verwaltet, CL/CEO entscheiden, HR/COMP lesen; ADM ohne Zugriff.
        roles: ['HR', 'PERF', 'COMP', 'CL', 'CEO'],
        order: 240,
        area: 'Performance',
        readOnly: ['HR', 'COMP'],
      },
    ],
  },
});
